import React, { useEffect, useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { auth } from '../firebaseConfig';
import { useLocalizedNavigate } from '../hooks/useLocalizedNavigate';
import LocalizedLink from './LocalizedLink';
import MemorySettingsPanel from './MemorySettingsPanel';

const SettingsMemoryPage: React.FC = () => {
  const { t } = useTranslation('settings');
  const navigate = useLocalizedNavigate();
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate('/');
      return;
    }
    setCheckingAuth(false);
  }, [navigate]);

  if (checkingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-black"></div>
      </div>
    );
  }

  return (
    <div className="sl-settings-shell min-h-screen p-8">
      <div className="mx-auto max-w-6xl">
        <LocalizedLink
          to="/settings"
          className="mb-4 inline-flex items-center gap-2 text-sm text-slate-600 transition-colors hover:text-slate-900 dark:text-slate-300 dark:hover:text-slate-100"
        >
          <ChevronLeft className="h-4 w-4" />
          {t('settings.back_to_settings')}
        </LocalizedLink>
        <MemorySettingsPanel />
      </div>
    </div>
  );
};

export default SettingsMemoryPage;
